import React, { useState } from "react";
import { FaChevronRight, FaPlus, FaSearch } from "react-icons/fa";
import { IoSend } from "react-icons/io5";

import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import PrimaryHeader from "../PrimaryHeader/PrimaryHeader";
import ParentComponent from "../ParentComponent/ParentComponent";
import DropDownComponent from "../DropDown/DropDown";
import DropDownCustom from "../DropDownCustom/DropDownCustom";
import { sendRemider } from "../../Actions/actions";
import Loader from "../Loader/Loader";

const Bill = () => {
  const { bill, loginData, subLoader } = useSelector(
    (state) => state.userReducer
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [selectedStatus, setSelectedStatus] = useState("All");
  const [currentIndex, setCurrentIndex] = useState(null);

  const [searchTerm, setSearchTerm] = useState("");
  const billingStatus = [
    { value: "All", label: "All" },
    { value: "pending", label: "Pending" },
    { value: "paid", label: "Paid" },
    { value: "overdue", label: "Over Due" },
  ];
  const filteredBills = bill?.filter((item) => {
    return (
      item.clientName.toLowerCase().includes(searchTerm.toLowerCase()) &&
      (selectedStatus === "All" ||
        item.status.toLowerCase() === selectedStatus.toLowerCase())
    );
  });

  return (
    <ParentComponent>
      <PrimaryHeader />
      <div className="bg-white rounded-t-lg mb-4 flex flex-col md:flex-row items-center md:space-x-6 space-y-4 md:space-y-0">
        <div className="relative w-full md:w-4/6">
          <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
          <input
            type="text"
            placeholder="Search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="border border-gray-300 rounded-lg pl-10 pr-4 py-2 w-full focus:outline-none focus:ring-2 focus:ring-[#361D32]"
          />
        </div>
        <div className="w-full md:w-2/6 flex flex-col md:flex-row md:space-x-4 space-y-4 md:space-y-0">
          <DropDownCustom
            isAligned={true}
            selectedValue={billingStatus?.find(
              (option) => option.value === selectedStatus
            )}
            handleChanges={(selectedOption) =>
              setSelectedStatus(selectedOption.value)
            }
            options={billingStatus}
            isSearchable={false}
            label={"Status"}
            placeholder="Select Status"
          />
          {/* <DropDownComponent
                        label={selectedStatus.label}
                        value={selectedStatus.value}
                        onChange={setSelectedStatus}
                        data={[
                            { value: "", label: "All" },
                            { value: "pending", label: "Pending" },
                            { value: "paid", label: "Paid" },
                            { value: "overdue", label: "Over Due" },
                        ]}
                    /> */}
        </div>
      </div>

      <div className="rounded-lg shadow-md bg-white relative">
        <div className="overflow-x-auto min-w-full rounded-lg">
          <table className="min-w-full text-left">
            <thead className="bg-gray-100 text-left">
              <tr className="text-gray-500 text-sm">
                <th className="py-4 px-4 min-w-[120px]">Client Name</th>
                <th className="py-4 min-w-[100px] text-center">Status</th>
                <th className="py-4 min-w-[100px] text-center">
                  Total Amount Due
                </th>
                <th className="py-4 min-w-[120px] text-center">Due Date</th>
                <th className="py-4 min-w-[150px]">Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredBills?.length > 0 ? (
                filteredBills?.map((task, index) => (
                  <tr key={index} className="border-b">
                    <td className="pl-4 py-4">
                      <span className="text-sm">{task.clientName}</span>
                    </td>
                    <td className="py-4 text-center">
                      <span
                        className={`text-xs px-3 py-1  font-semibold rounded ${
                          task.status === "pending"
                            ? "bg-yellow-200 text-yellow-800"
                            : "bg-green-200 text-green-700"
                        }`}
                      >
                        {task.status === "pending" ? "Pending" : "Paid"}
                      </span>
                    </td>
                    <td className="py-4 text-center">
                      <span className="text-sm text-gray-700 px-3 ">
                        AED {task.totalAmountDue}
                      </span>
                    </td>
                    <td className="text-sm py-4 text-center">
                      {moment(task.subscriptionExpiryDate).format("DD-MMM-yy")}
                    </td>
                    <td className="py-4">
                      {task.status !== "paid" &&
                        (subLoader && index == currentIndex ? (
                          <div className="flex ml-4">
                            <div className="justify-self-center">
                              <div className="w-7 h-7 border-4 border-t-4 border-gray-200 border-t-primary rounded-full animate-spin"></div>
                            </div>
                          </div>
                        ) : (
                          <button
                            className="flex items-center text-gray-700 px-3 py-1 bg-gray-300 rounded hover:bg-gray-400"
                            onClick={() => {
                              dispatch(
                                sendRemider(
                                  task.clientId,
                                  loginData?.accessToken
                                )
                              );
                              setCurrentIndex(index);
                            }}
                          >
                            <IoSend className="w-3 h-3 mr-1 text-black" />
                            <span className="text-xs">Send Reminder</span>
                          </button>
                        ))}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center py-4 text-gray-500">
                    No bill found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </ParentComponent>
  );
};

export default Bill;
